<!--
 * @Descripttion: 
 * @version: 手机号等敏感字段信息数据脱敏
 * @Author: wlk
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-12-16 14:49:23
-->
<template>
  <span class="decrypt">
    {{ showEye ? props.phone : fechPhoneData.result.value }}
    <EyeInvisibleTwoTone v-show="showEye" @click="getCardId" class="real-user-show" two-tone-color="#44B190" />
    <EyeTwoTone v-show="!showEye" @click="getCardId" class="real-user-show" two-tone-color="#44B190" />
  </span>
</template>
<script setup lang="ts" name="DecryptIdCard">
  import { ref } from 'vue'
  import { EyeTwoTone, EyeInvisibleTwoTone } from '@ant-design/icons-vue'
  import { getPhoneService } from '@/service/api'
  import { useApi } from '@tmp/site-common'

  interface Props {
    id: string
    phone: string
    /** 场景值 */
    scenes: string
  }
  const props = defineProps<Props>()
  /**查看手机号 */
  const showEye = ref(true)
  const fechPhoneData = useApi(getPhoneService.getPhone)
  const getCardId = () => {
    showEye.value = !showEye.value

    const res = fechPhoneData.fetchData({
      paramOne: props.id,
      paramTwo: props.scenes,
      paramThree: props.phone
    })
  }
</script>
<style lang="less" scoped>
  .decrypt {
    .real-user-show {
      cursor: pointer;
      margin-left: 4px;
    }
  }
</style>
